import Service from '../Service';

export default class OaApiService extends Service {
  constructor(apiHandler) {
    super(apiHandler);
    this.baseUrl = process.env.VUE_APP_API_URL;
  }
}
